import type {InMemoryLogger} from 'core/logging/in-memory-logger';
import {generateAndDownloadReport} from 'core/debug-util/report-generator';
import {captureAndDownloadScreenshot} from 'core/debug-util/screenshot';

const GENERATE_REPORT_SHORTCUT_KEY = 'KeyD';
const CAPTURE_SCREENSHOT_SHORTCUT_KEY = 'KeyS';

const GENERATE_REPORT_EVENT = 'generate-report';
const CAPTURE_SCREENSHOT_EVENT = 'capture-screenshot';

export function setupDebugListeners(logger: InMemoryLogger): void {
    document.addEventListener('keydown', createDebugShortcutsListener(logger));
    document.addEventListener(GENERATE_REPORT_EVENT, (event: CustomEvent<string>) => generateAndDownloadReport(logger, event.detail));
    document.addEventListener(CAPTURE_SCREENSHOT_EVENT, () => {captureAndDownloadScreenshot()});
}

export function triggerGenerateReportEvent(optionalInfo?: string): void {
    document.dispatchEvent(new CustomEvent(GENERATE_REPORT_EVENT, {detail: optionalInfo}));
}

export function triggerCaptureScreenshotEvent(): void {
    document.dispatchEvent(new CustomEvent(CAPTURE_SCREENSHOT_EVENT));
}

function createDebugShortcutsListener(logger: InMemoryLogger) {
    return (event: KeyboardEvent) => {

        if (!event.shiftKey && event.ctrlKey && event.altKey && event.code === GENERATE_REPORT_SHORTCUT_KEY) {
            event.preventDefault();
            generateAndDownloadReport(logger);
        }

        if (!event.shiftKey && event.ctrlKey && event.altKey && event.code === CAPTURE_SCREENSHOT_SHORTCUT_KEY) {
            event.preventDefault();
            captureAndDownloadScreenshot();
        }
    }
}